import { useLogAnalyticsEvent, useMount } from 'shared/src/hooks';

export const useLogViewEvent = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useMount(() => {
    logAnalyticsEvent({
      name: 'VIEW_SETTING',
      channel: ['firebase', 'amplitude', 'ablylog'],
    });
  });
};
